import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';
import qs from 'qs';
import { query } from '../gql/getWaivers';

export default graphql(
  gql`
    mutation UpdateWaiver($input: UpdateWaiverInput!) {
      updateWaiver(input: $input) {
        id
        waiver_id
        name
        company
        type
        status
        requires_spouse
        requires_minor
        is_minor_waiver
        notes
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      updateWaiver: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
            refetchQueries: () => {
              const search = qs.parse(window.location.search, {
                ignoreQueryPrefix: true,
              });
              return [{ query, variables: { input: search } }];
            },
          })
        );
      },
    }),
  }
);
